import { Flex } from "@chakra-ui/react"
import { ICustomer } from "types/customer"

export const getInsideActions = ({T ,clientReservationsClick ,clientAutosClick , clientTransactionsClick
}: any) => [
  {
    key: "booking",
    render: (data: ICustomer) =>
    <Flex 
      cursor="pointer" 
      onClick={()=>clientReservationsClick(data)} 
      h={"34px"} 
      padding={"10px 13px"} 
      borderRadius={"base"} 
      w={"auto"} 
      bgColor="#E9F2FD" 
      alignItems={"center"} 
      justifyContent="center" 
      color={"black"} 
      fontSize="12px"
    >
      {T("customers.table.columns.bookings")}
    </Flex>
  },
  {
    key: "transaction",
    render: (data: ICustomer) =>
    <Flex 
      cursor="pointer"  
      onClick={() => clientTransactionsClick(data)} 
      h={"34px"} 
      w={"auto"} 
      padding={"10px 13px"} 
      borderRadius={"base"}  
      bgColor="#E9F2FD" 
      alignItems={"center"} 
      justifyContent="center" 
      color={"black"} 
      fontSize="12px"
    >
      {T("customers.table.columns.transactions")}
    </Flex>
  },
  {
    key: "auto",
    render: (data: ICustomer) =>
    <Flex 
      cursor="pointer"  
      onClick={()=>clientAutosClick(data)}
      h={"34px"} 
      w={"auto"} 
      padding={"10px 13px"} 
      borderRadius={"base"}  
      bgColor="#E9F2FD" 
      alignItems={"center"} 
      justifyContent="center" 
      color={"black"} 
      fontSize="12px"
    >
      {T("customers.table.columns.autos")}
    </Flex>
  }
]
